module.exports = __webpack_public_path__ + "static/media/logos-company.a64de603.svg";